import { RawTextCell, TooltipCell } from '@/components/Table/components/Cell'
import { FilterType } from '@/components/Table/components/Filter/TableFilter'
import { Flex } from '@chakra-ui/react'
import { createColumnHelper } from '@tanstack/react-table'
import React from 'react'
import { MdDeleteOutline, MdOutlineCheckCircle } from 'react-icons/md'

const getContributorGroupTableColumns = ({ handleDelete, handleActivate }) => {
  const columnHelper = createColumnHelper()

  return [
    columnHelper.display({
      id: 'action',
      size: 100,
      enableHiding: false,
      enableColumnFilter: false,
      cell: ({ row: { original } }) => {
        return (
          <>
            {original?.status === 'active' && (
              <Flex _hover={{ cursor: 'pointer' }} color="gray.400" justifyContent={'center'} w="100%">
                <MdDeleteOutline
                  size={24}
                  onClick={(e) => {
                    e.stopPropagation()
                    handleDelete(original._id)
                  }}
                />
              </Flex>
            )}
            {original?.status === 'inactive' && (
              <Flex _hover={{ cursor: 'pointer' }} color="green.400" justifyContent={'center'} w="100%">
                <MdOutlineCheckCircle
                  size={24}
                  onClick={(e) => {
                    e.stopPropagation()
                    handleActivate(original._id)
                  }}
                />
              </Flex>
            )}
          </>
        )
      },
    }),

    columnHelper.accessor('type', {
      header: () => <span>Code</span>,
      cell: RawTextCell,
    }),
    columnHelper.accessor('name', {
      cell: RawTextCell,
    }),
    columnHelper.accessor('defaultUser', {
      cell: ({ getValue }) => {
        const user = getValue()

        if (!user?.firstName || !user?.lastName) {
          return ''
        }

        return <TooltipCell text={`${user?.firstName} ${user?.lastName}`} />
      },
    }),
    columnHelper.accessor('status', {
      meta: {
        filterVariant: FilterType.MULTI_SELECT,
        filterOptions: [
          { label: 'Active', value: 'active' },
          { label: 'Inactive', value: 'inactive' },
          { label: 'Temporary', value: 'temporary' },
          { label: 'Listed', value: 'listed' },
        ],
      },
    }),
    columnHelper.accessor('requiredInOffer', {
      meta: {
        filterVariant: FilterType.SELECT_YES_NO,
      },
    }),
  ]
}

export default getContributorGroupTableColumns
